/* tslint:disable */
import { SelectedMeshPointElm } from './selected-mesh-point-elm';

/**
 */
export class SelectedMeshPoint {
    AXE1_X?: SelectedMeshPointElm;
    POINT1_X?: SelectedMeshPointElm;
    POINT1_Z?: SelectedMeshPointElm;
    POINT2_X?: SelectedMeshPointElm;
    POINT2_Y?: SelectedMeshPointElm;
    POINT2_Z?: SelectedMeshPointElm;
    POINT3_X?: SelectedMeshPointElm;
    POINT3_Y?: SelectedMeshPointElm;
    POINT3_Z?: SelectedMeshPointElm;
    POINT1_Y?: SelectedMeshPointElm;
    AXE1_Y?: SelectedMeshPointElm;
    AXE2_X?: SelectedMeshPointElm;
    AXE2_Z?: SelectedMeshPointElm;
    AXE3_Y?: SelectedMeshPointElm;
    AXE3_Z?: SelectedMeshPointElm;
    PLAN_X?: SelectedMeshPointElm;
    PLAN_Y?: SelectedMeshPointElm;
    PLAN_Z?: SelectedMeshPointElm;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/selected-mesh-point.ts